import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="w-full border-y border-navy/10 bg-white py-10 sm:py-14" data-id="element-152" data-mp="1tarjq9bipqkw">
      <dl className="mx-auto grid max-w-6xl grid-cols-2 gap-y-8 px-5 md:grid-cols-4 md:gap-y-0" data-id="element-153" data-mp="1t8nk43knjdqf">
        {stats.map((stat, index) => <div key={stat.label} className={`px-4 text-center ${index > 0 ? 'md:border-l md:border-navy/10' : ''}`} data-id="element-154" data-mp="1jd3ozjdwwj2q" data-mpi={index}>
            <dt className="sr-only" data-id="element-155" data-mp="19mr57tdx8txn">{stat.label}</dt>
            <dd data-id="element-156" data-mp="19kxv2443nrkw">
              <span className="block font-display text-3xl font-black text-navy sm:text-4xl" data-id="element-157" data-mp="19keg8w9qxjb3">
                {stat.value}
              </span>
              <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.16em] text-navy/45 sm:text-[11px]" data-id="element-158" data-mp="10mlzdnodm3ll">
                {stat.label}
              </span>
            </dd>
          </div>)}
      </dl>
    </section>;
}